
// #721 round 2 (spec §6, D23): the summary's plan list, rendered as
// "Potential Plans" inside the AEP builder (current plans filtered out by the
// parent) or as "Plans list" in its old place outside AEP mode.
import { mapGetters } from 'vuex'

export default {
    props: {
        label: { type: String, default: 'Plans list' },
        plans: { type: Array, default: () => [] },
        search: { type: Function, required: true },
        aep: { type: Boolean, default: false },
        isCurrentPlan: { type: Function, default: () => false },
        emptyText: { type: String, default: 'No plans added' },
    },
    computed: {
        ...mapGetters(['fullservePlus', 'canAgent', 'isPlanCommissionable', 'isPlanEnrollable']),
    },
}
